import Expense from "./components/Expenses/Expense";
import NewExpense from "./components/NewExpense/NewExpense";
import React, { useState} from 'react';


  
  const DUMMY_EXPENSES = [
    {
      id: "e1",
      title: "Internet",
      amount: 94.12,
      date: new Date(2020, 7, 14),
    },
    { id: "e2", title: "New TV", amount: 799.49, date: new Date(2021, 2, 12) },
    {
      id: "e3",
      title: "Car Insurance",
      amount: 294.67,
      date: new Date(2021, 2, 28),
    },
    {
      id: "e4",
      title: "New Desk (Wooden)",
      amount: 450,
      date: new Date(2021, 5, 12),
    },
    
  ];

  function App() {
    const [expenses, setExpenses] = useState(DUMMY_EXPENSES);

    function addExpenseHandler(expense){
      setExpenses((prevExpenses) => {
        return [expense, ...prevExpenses]
      });

    }
  




  /* function addExpenseHandler(expense){
    console.log("In App.js");
    console.log(expense);
  }; */
  
   function addYearHandler(fill){
    console.log(fill);
  }; 



  return (
    <div>
      <NewExpense onAddExpense={addExpenseHandler} />
      <Expense items={expenses} onAddYearfilt={addYearHandler} />
      
    </div>
  );
  }

export default App;
